import { 
  FaFacebookF, 
  FaInstagram, 
  FaWhatsapp, 
  FaTiktok, 
  FaLinkedinIn, 
  FaXTwitter 
} from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import './SocialRow.css';

const SocialRow = ({ socialMediaLinks, iconColor }) => {
  if (!socialMediaLinks) return null;

  const iconMap = {
    facebook: FaFacebookF,
    instagram: FaInstagram,
    whatsapp: FaWhatsapp,
    tiktok: FaTiktok,
    linkedin: FaLinkedinIn,
    twitter: FaXTwitter,
    email: MdEmail,
  };

  const socialNetworks = Object.keys(socialMediaLinks).filter(
    (key) => socialMediaLinks[key] && socialMediaLinks[key].length > 0
  );

  if (socialNetworks.length === 0) return null;

  return (
    <div className="social-row">
      {socialNetworks.map((network) => {
        const links = socialMediaLinks[network];
        if (!links || links.length === 0) return null;
        
        const firstLink = links[0];
        const networkKey = network.toLowerCase();
        
        // Check if it's an email link (either by key or URL)
        const isEmail = networkKey === 'email' || firstLink?.url?.startsWith('mailto:');
        const IconComponent = isEmail ? MdEmail : iconMap[networkKey];
        
        if (!IconComponent || !firstLink?.url) return null;

        const DisplayIcon = IconComponent;

        return (
          <a
            key={network}
            href={firstLink.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-link"
            style={{ color: iconColor || '#FFFFFF' }}
            aria-label={firstLink.name || network}
          >
            {DisplayIcon && <DisplayIcon />}
          </a>
        );
      })}
    </div>
  );
};

export default SocialRow;

